import {
  HiveCanvasTextFonts,
  FontConfigExtension,
} from '@blocksuite/hive/shared/services';

export function getFontConfigExtension() {
  return FontConfigExtension(
    HiveCanvasTextFonts.map(font => ({
      ...font,
      url: environment.publicPath + 'fonts/' + font.url.split('/').pop(),
    }))
  );
}
